import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";

import { fn } from "util";
import Moment from "moment";
import { If, IconButton, TextField, StyledButton } from "components/support";
import Divider from "material-ui/Divider";
import Paper from "material-ui-next/Paper";
import Typography from "material-ui-next/Typography";
import Toggle from "material-ui/Toggle";

import FlatButton from "material-ui/RaisedButton";
import AcceptIcon from "material-ui/svg-icons/action/done";
import CloseIcon from "material-ui/svg-icons/content/clear";

import style from "./style";

class Device extends Component {
  render() {
    const {
      className,
      device,
      currentUser,
      onToggle,
      onChange,
      onAccept,
      onClose,
      onSaveConfig,
      onChangeConfig
    } = this.props;
    const {
      name,
      uuid,
      config,
      updated_at,
      enabled,
      lastSalesman,
      disabled,
      edit_serie
    } = device;
    const { serie, nfce_last_number, receipt_last_number } = config;

    const { company } = currentUser;
    const { emission_token, address, fiscal_informations } = company;
    const { uf_code, street, neighborhood, zipcode, city, state } = address;
    const { cnpj, municipal_code, crt_code, ie } = fiscal_informations;
    const company_name = company.name;

    const hasFiscalInformation =
      !fn.isBlank(emission_token) &&
      !fn.isBlank(company_name) &&
      !fn.isBlank(uf_code) &&
      !fn.isBlank(street) &&
      !fn.isBlank(neighborhood) &&
      !fn.isBlank(zipcode) &&
      !fn.isBlank(city) &&
      !fn.isBlank(state) &&
      !fn.isBlank(cnpj) &&
      !fn.isBlank(municipal_code) &&
      !fn.isBlank(crt_code) &&
      !fn.isBlank(ie);

    const last_number = hasFiscalInformation
      ? nfce_last_number
      : receipt_last_number;

    return (
      <div className={className}>
        <Paper elevation={3} className="full-height grid-container p-sm mb-sm">
          <Row>
            <Col xs={12} md={9}>
              <Row>
                <Col xs>
                  <div style={{ display: "flex" }}>
                    <TextField
                      underlineShow={false}
                      value={name}
                      transparent
                      font="Roboto"
                      fieldWidth={215}
                      disabled={disabled}
                      onChange={(_, value) => onChange("name", value)}
                    />

                    <If test={!!disabled}>
                      <IconButton
                        style={{ marginTop: 13 }}
                        mini
                        icon="mode_edit"
                        onClick={() => onChange("disabled", false)}
                      />
                    </If>

                    <If test={!disabled}>
                      <FlatButton
                        icon={<AcceptIcon />}
                        style={{
                          boxShadow: "none",
                          margin: "15px 5px",
                          minWidth: 20,
                          height: 25
                        }}
                        onClick={() => onAccept()}
                      />
                      <FlatButton
                        icon={<CloseIcon />}
                        style={{
                          boxShadow: "none",
                          margin: "15px 5px",
                          minWidth: 20,
                          height: 25
                        }}
                        onClick={() => onClose()}
                      />
                    </If>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col xs={12}>
                  <span className="text-muted uuid-text">{uuid}</span>
                </Col>
              </Row>
            </Col>
            <Col md>
              <Row middle="xs" className="full-height text-right">
                <Col xs={12}>
                  <Toggle
                    toggled={enabled}
                    onToggle={(_, toggle) => onToggle(device, toggle)}
                    trackStyle={{ backgroundColor: "#ffa3a3" }}
                    thumbStyle={{ backgroundColor: "#c70101" }}
                    trackSwitchedStyle={{ backgroundColor: "#97dc97" }}
                    thumbSwitchedStyle={{ backgroundColor: "#158e15" }}
                  />
                </Col>
              </Row>
            </Col>
          </Row>

          <Divider className="mv-sm" />
          <Row end="xs">
            <Col xs={12}>
              <IconButton
                mini
                icon="build"
                onClick={() => {
                  onChange("edit_serie", !edit_serie);
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <Typography type="subheading">
                {lastSalesman
                  ? `Última venda: ${lastSalesman}`
                  : "Não há vendas nesse dispositivo"}
              </Typography>
            </Col>
            <Col xs={12} md={5}>
              <If test={edit_serie}>
                <TextField
                  label="Série"
                  value={serie}
                  fieldWidth={100}
                  onChange={(_, value) => onChangeConfig("serie", value)}
                />
              </If>

              <If test={!edit_serie}>
                <Typography type="subheading">Série: {serie}</Typography>
              </If>
            </Col>
            <Col xs={12} md={5}>
              <If test={edit_serie}>
                <TextField
                  label="Última numeração"
                  value={last_number || 0}
                  fieldWidth={200}
                  onChange={(_, value) => {
                    const number = hasFiscalInformation
                      ? "nfce_last_number"
                      : "receipt_last_number";
                    onChangeConfig(number, value);
                  }}
                />
              </If>

              <If test={!edit_serie}>
                <Typography type="subheading">
                  Última numeração: {last_number || 0}
                </Typography>
              </If>
            </Col>
          </Row>
          <Row center="xs">
            <If test={edit_serie}>
              <Col xs={12}>
                <StyledButton
                  label="Salvar dados do dispositivo"
                  primary={true}
                  style={{ margin: 10 }}
                  onTouchTap={() => onSaveConfig()}
                >
                  Salvar dados do dispositivo
                </StyledButton>
              </Col>
            </If>
          </Row>
          <Row>
            <If test={currentUser.is_admin}>
              <Col xs={11}>
                <Typography type="subheading">
                  Última atualização:{" "}
                  {Moment(updated_at).format("DD/MM [às] HH:mm")}
                </Typography>
              </Col>
            </If>
            <If test={!currentUser.is_admin}>
              <Col xs={12}>
                <Typography type="subheading">
                  Última atualização:{" "}
                  {Moment(updated_at).format("DD/MM [às] HH:mm")}
                </Typography>
              </Col>
            </If>
          </Row>
        </Paper>
      </div>
    );
  }
}

export default style(Device);



// WEBPACK FOOTER //
// ./src/components/app/registration/device/list/device/index.jsx